/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaOverlay/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/** @type {import('Simple/types.js').View} */
export default function TysiaOverlay({
  children,
  viewPath = "/DesignSystem/TysiaOverlay",
  id,
  dangerouslyBypassFocusLock = true,
  dangerouslyBypassScrollLock = true,
  isModal = true,
  isOpen = true,
  alignItems = "center",
  justifyContent = "center",
  position = "fixed",
  left = "auto",
  bottom,
  right,
  top,
  zIndex = 1000,
  onClick,
  onDismiss,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderWidth = 1,
  borderStyle = "solid",
  borderColor,
  width = "400px",
  minWidth = "auto",
  paddingTop = 0,
  paddingBottom = 0,
  paddingLeft = 0,
  paddingRight = 0
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let bottomOrdtSpaceS = bottom ?? dtSpaceS
let rightOrdtSpaceS = right ?? dtSpaceS
let topOrdtSpaceS = top ?? dtSpaceS
let borderBottomLeftRadiusOrdtSpaceXs = borderBottomLeftRadius ?? dtSpaceXs
let borderBottomRightRadiusOrdtSpaceXs = borderBottomRightRadius ?? dtSpaceXs
let borderTopLeftRadiusOrdtSpaceXs = borderTopLeftRadius ?? dtSpaceXs
let borderTopRightRadiusOrdtSpaceXs = borderTopRightRadius ?? dtSpaceXs
let borderColorOrdtColorsNeutral200 = borderColor ?? dtColorsNeutral200
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="TysiaOverlay.Vertical"
  data-view-path={viewPath}
 id={id}
 dangerouslyBypassFocusLock={dangerouslyBypassFocusLock}
 dangerouslyBypassScrollLock={dangerouslyBypassScrollLock}
 isOpen={isOpen}
 {...isHoveredBind}
 onClick={onClick}
 onDismiss={onDismiss}
 style={{'--ai-1-Zh290q': alignItems,'--jc-2-Zh290q': justifyContent,'--p-3-Zh290q': position,'--l-4-Zh290q': typeof left === 'number' ? `${left}px` : left,'--b-5-Zh290q': typeof bottomOrdtSpaceS === 'number' ? `${bottomOrdtSpaceS}px` : bottomOrdtSpaceS,'--r-6-Zh290q': typeof rightOrdtSpaceS === 'number' ? `${rightOrdtSpaceS}px` : rightOrdtSpaceS,'--t-7-Zh290q': typeof topOrdtSpaceS === 'number' ? `${topOrdtSpaceS}px` : topOrdtSpaceS,'--zi-8-Zh290q': zIndex,'--bblr-9-Zh290q': typeof borderBottomLeftRadiusOrdtSpaceXs === 'number' ? `${borderBottomLeftRadiusOrdtSpaceXs}px` : borderBottomLeftRadiusOrdtSpaceXs,'--bbrr-10-Zh290q': typeof borderBottomRightRadiusOrdtSpaceXs === 'number' ? `${borderBottomRightRadiusOrdtSpaceXs}px` : borderBottomRightRadiusOrdtSpaceXs,'--btlr-11-Zh290q': typeof borderTopLeftRadiusOrdtSpaceXs === 'number' ? `${borderTopLeftRadiusOrdtSpaceXs}px` : borderTopLeftRadiusOrdtSpaceXs,'--btrr-12-Zh290q': typeof borderTopRightRadiusOrdtSpaceXs === 'number' ? `${borderTopRightRadiusOrdtSpaceXs}px` : borderTopRightRadiusOrdtSpaceXs,'--bw-13-Zh290q': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--bs-14-Zh290q': borderStyle,'--bc-15-Zh290q': borderColorOrdtColorsNeutral200,'--w-16-Zh290q': typeof width === 'number' ? `${width}px` : width,'--mw-17-Zh290q': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--pt-18-Zh290q': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-19-Zh290q': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-20-Zh290q': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-21-Zh290q': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</ViewsModalOverlay>
</React.Fragment>)
}